import type { AxiosInstance } from 'axios';
import { transformReservations } from '@/api/transforms/reservation';
import startOfToday from 'date-fns/startOfToday';
import endOfToday from 'date-fns/endOfToday';
import setHours from 'date-fns/fp/setHours';
import addHours from 'date-fns/fp/addHours';
import format from 'date-fns/fp/format';
import { ReservationModel } from '@/models/reservation';
import { Reservation } from '@/api/types/reservation';
import addSeconds from 'date-fns/fp/addSeconds';

class ReservationService {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getTodaysReservations() : Promise<ReservationModel[]> {
    const startDate = format('yyyy-MM-dd\'T\'HH:mm:ss')(setHours(1)(startOfToday()));
    const endDate = format('yyyy-MM-dd\'T\'HH:mm:ss')(addSeconds(1)(addHours(3)(endOfToday())))

    const response = await this.client.get<Reservation[]>('/reservations', {
      params: {
        'status[$ne]': 'canceled',
        'startDate[$gte]': startDate,
        'startDate[$lt]': endDate,

        '$expand': [
          'customer',
          'property',
          'reservationNotes',
          'reservationTags',
          'customer.customerTags',
          'customer.customerTags.tag',
          'customer.customerNotes',
          'customer.customerNotes.createdByUser',
          'customer.customerNotes.customerNoteTags',
          'customer.customerNotes.customerNoteTags.tag'
        ]
      }
    });

    return transformReservations(response.data.data);
  }
}

export { ReservationService };
